import { Link } from "gatsby";
import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { FaChevronCircleUp } from "react-icons/fa";

export default function Navbar() {
  return (
    <header>
      <nav id="navBar">
        <input id="menuToggle" type="checkbox" />
        <div className="menuIcon">
          <span className="firstLine"></span>{" "}
          <span className="secondLine"></span>
          <span className="thirdLine"></span>
        </div>
        <div>
          <Link to="/" className="logo">
            <StaticImage
              src="../images/misc/map_logo.png"
              alt="map logo"
              width={30}
            />
            <h1>LUXERA'S MAP</h1>
          </Link>
        </div>
        <div className="links">
          <Link to="/tournaments">TOURNAMENT REPORTS</Link>
          <Link to="/articles">ARTICLES</Link>
          {/* <Link to="/toolbox">TOOLBOX</Link> */}
          <Link to="/contributors">CONTRIBUTORS</Link>
        </div>
        <Link to="#layoutPoint" className="backTop">
          <FaChevronCircleUp />
        </Link>
      </nav>
    </header>
  );
}
